import {
  CHOICE,
  ROBOTS,
  SMALLS,
  BULK,
  DEFAULT,
  COLLECTIONS,
  OVERRIDES,
  LOCATIONS,
  PICKUP,
} from "./strings";

export const CHOICE_PLAN_TYPE = "I";
export const ROBOTS_PLAN_TYPE = "R";
export const SMALLS_PLAN_TYPE = "S";
export const BULK_PLAN_TYPE = "B";
export const DEFAULT_PLAN_TYPE = "D";
export const COLLECTIONS_PLAN_TYPE = "C";
export const OVERRIDES_PLAN_TYPE = "O";
export const LOCATIONS_PLAN_TYPE = "L";
export const PICKUP_PLAN_TYPE = "P";

export const PLAN_TYPES_BY_NAME = {
  [CHOICE]: CHOICE_PLAN_TYPE,
  [ROBOTS]: ROBOTS_PLAN_TYPE,
  [SMALLS]: SMALLS_PLAN_TYPE,
  [BULK]: BULK_PLAN_TYPE,
  [DEFAULT]: DEFAULT_PLAN_TYPE,
  [COLLECTIONS]: COLLECTIONS_PLAN_TYPE,
  [PICKUP]: PICKUP_PLAN_TYPE,
  [OVERRIDES]: OVERRIDES_PLAN_TYPE,
  [LOCATIONS]: LOCATIONS_PLAN_TYPE,
};

export const PLAN_TYPE_NAMES = {
  [CHOICE_PLAN_TYPE]: CHOICE,
  [ROBOTS_PLAN_TYPE]: ROBOTS,
  [SMALLS_PLAN_TYPE]: SMALLS,
  [BULK_PLAN_TYPE]: BULK,
  [DEFAULT_PLAN_TYPE]: DEFAULT,
  [COLLECTIONS_PLAN_TYPE]: COLLECTIONS,
  [PICKUP_PLAN_TYPE]: PICKUP,
  [OVERRIDES_PLAN_TYPE]: OVERRIDES,
  [LOCATIONS_PLAN_TYPE]: LOCATIONS,
};

// TODO remove filter to enable ROBOTS
export const PLAN_TYPES = Object.values(PLAN_TYPES_BY_NAME).filter(
  (planType) => ![ROBOTS_PLAN_TYPE].includes(planType)
);

export const PLAN_TYPES_IMPORTANCE_ORDER = [
  DEFAULT_PLAN_TYPE,
  ...PLAN_TYPES.filter((planType) => planType !== DEFAULT_PLAN_TYPE),
];

export const NON_DELIVERY_PLAN_TYPES = [
  COLLECTIONS_PLAN_TYPE,
  OVERRIDES_PLAN_TYPE,
  PICKUP_PLAN_TYPE,
  LOCATIONS_PLAN_TYPE,
];
export const DELIVERY_PLAN_TYPES = PLAN_TYPES.filter(
  (planType) => !NON_DELIVERY_PLAN_TYPES.includes(planType)
);
export const TYPES_WITHOUT_TIMEBAND = NON_DELIVERY_PLAN_TYPES;
